import React from 'react';
import PropTypes from 'prop-types';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import { analyticsChartTheme } from 'util/chartUtils';
import IntlMessages from '../../../../util/IntlMessages';
import DashboardPanel from './DashboardPanel';
import DashboardDonut from './DashboardDonut';
import styles from './DashboardChart.module.scss';

const Audience = ({ audience }) => {
  const localizeMessage = useLocalizedMessage();
  const empty = !audience || Boolean(audience.error);
  const model = audience || {};
  const data = [
    { name: localizeMessage('dashboard.audience.chart.usedSearch'), value: model.search || 0, color: analyticsChartTheme.searches },
    { name: localizeMessage('dashboard.audience.chart.noSearch'), value: model.noSearch || 0, color: analyticsChartTheme.clickRate },
    { name: localizeMessage('dashboard.audience.chart.lowQuality'), value: model.bad || 0, color: analyticsChartTheme.previous },
  ];

  return (
    <DashboardPanel
      title={<IntlMessages id="dashboard.audience.header" />}
      tone="clickRate"
      empty={empty}
      emptyVariant="donut"
    >
      <div className={styles.split}>
        <div>
          <p className={styles.lead}>
            {localizeMessage('dashboard.audience.usedSearch', { percentage: model.searchPercentage || 0 })}
          </p>
          <dl className={styles.metricList}>
            <div className={styles.metricRow}>
              <dt><IntlMessages id="dashboard.audience.table.totalVisitors" /></dt>
              <dd>{model.total || 0}</dd>
            </div>
            <div className={styles.metricRow}>
              <dt><IntlMessages id="dashboard.audience.table.interested" /></dt>
              <dd>{model.interested || 0}</dd>
            </div>
            <div className={styles.metricRow}>
              <dt><IntlMessages id="dashboard.audience.table.usedSearch" /></dt>
              <dd>{model.search || 0}</dd>
            </div>
          </dl>
        </div>
        <DashboardDonut data={data} centerLabel={`${model.searchPercentage || 0}%`} />
      </div>
    </DashboardPanel>
  );
};

Audience.propTypes = {
  audience: PropTypes.shape({
    bad: PropTypes.number,
    noSearch: PropTypes.number,
    search: PropTypes.number,
    searchPercentage: PropTypes.number,
    total: PropTypes.number,
    interested: PropTypes.number,
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }),
};

Audience.defaultProps = { audience: null };

export default Audience;
